// React
import React, {useState} from 'react';

// MUI
import {Select, Stack} from '@wellstone-solutions/web';

// WS
import {useStores} from 'hooks/useStores';
import {Palette} from 'palette';
import {HabitsScatterChart} from './HabitsScatterChart';

export const HabitsChart = (props) => {
  const {habitStore} = useStores();
  const [selectedFilterName, setSelectedFilterName] = useState('none');

  const filters = [
    {name: 'None', type: null, key: 'none'},
    ...habitStore.habitActivityFilters,
  ];

  const _getActiveFilter = () =>
    filters.find((filter) => filter.key === selectedFilterName);

  const _showActiveFilter = () => {
    const activeFilter = _getActiveFilter();
    if (activeFilter.key !== 'none') {
      return `Filter by ${activeFilter.name}`;
    }
  };

  const _handleFilterChange = (event) => {
    setSelectedFilterName(event.target.value);
  };

  if (!props.habitData) {
    return null;
  }

  return (
    <div style={styles.container}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={styles.filterContainer}>
        <div>{_showActiveFilter()}</div>

        <Stack direction="row" spacing={1} alignItems="center">
          <span style={styles.viewBy}>Filter</span>
          <Select
            value={selectedFilterName}
            onChange={_handleFilterChange}
            id="habits-filter-button"
            items={filters.map((filter) => ({
              value: filter.key || 'none',
              label: filter.name,
            }))}
            canUnselect={false}
            containerProps={{
              size: 'small',
              sx: {minWidth: 150},
            }}
          />
        </Stack>
      </Stack>
      <HabitsScatterChart
        size={{height: 400, width: '95%'}}
        filterData={_getActiveFilter()}
        scatterData={props.habitData}
        x={{key: props.aggregator, type: 'category'}}
        y={{key: 'index', type: 'number'}}
      />
    </div>
  );
};

const styles = {
  container: {
    minHeight: '355px',
  },
  filterContainer: {
    marginBottom: 0,
  },
  viewBy: {
    marginRight: 10,
    fontWeight: 'bold',
    color: Palette.INFO,
  },
};
